// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-db461342]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.exchange[data-v-db461342] {\n  background: #fff;\n  border-radius: 10px;\n  padding: 0 15px;\n}\n.exchange .nav[data-v-db461342] {\n  padding: 10px 0;\n}\n.exchange .tb-slot-status[data-v-db461342] {\n  font-size: 14px;\n  color: #1f2d3d;\n  margin-left: 5px;\n}", ""]);
// Exports
module.exports = exports;
